var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lading-page"},[_c('div',{attrs:{"id":"content-landing"}},[_c('markets',{attrs:{"id":"markets_table_landing","visibleCoinName":""}})],1),_c('div',{staticClass:"clearfix"})])
}
var staticRenderFns = []

export { render, staticRenderFns }